module.exports = "\r\n<ol>\r\n  <li *ngFor=\"let phase of phases\">\r\n    {{phase}}<p>\r\n  </li>\r\n  <li>最近更新日期：{{date}}</li>\r\n</ol>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/home-page/home-page.component.html
// module id = 1180
// module chunks = 0